export default __webpack_public_path__ + "static/media/GreenLake_Demos.7df23aff.jpg";